module.exports = __webpack_public_path__ + "img/course data-no-text.c975e757.svg";